export enum DeviceDefectListActionTypes {
    SET_DEVICE_DEFECTLIST = "SET_DEVICE_DEFECTLIST",
    CLEAR_DEVICE_DEFECTLIST = "CLEAR_DEVICE_DEFECTLIST"
}

export enum TrailerDefectListActionTypes {
    SET_TRAILER_DEFECTLIST = "SET_TRAILER_DEFECTLIST",
    CLEAR_TRAILER_DEFECTLIST = "CLEAR_TRAILER_DEFECTLIST"
}